/*
 * App access request statuses (Launchpad API AppAccessRequestStatus).
 *
 *   New -> InReview (billing in progress) -> Approved -> Revoked
 *       -> NeedsAccount                   -> Denied
 *
 * Approved turns on ADAS Map Mobile for the linked user; Revoked turns it off.
 * The API owns the transition rules and sends the allowed next statuses with each request.
 */

export const AccessRequestStatus = {
  New: 'New',
  InReview: 'InReview',
  NeedsAccount: 'NeedsAccount',
  Approved: 'Approved',
  Denied: 'Denied',
  Revoked: 'Revoked'
}

/** Every status, in queue order, with its label and badge colour. */
export const accessRequestStatuses = [
  { value: AccessRequestStatus.New, name: 'New', badge: 'bg-primary' },
  { value: AccessRequestStatus.InReview, name: 'Billing in progress', badge: 'bg-info text-dark' },
  { value: AccessRequestStatus.NeedsAccount, name: 'Needs account', badge: 'bg-warning text-dark' },
  { value: AccessRequestStatus.Approved, name: 'Approved', badge: 'bg-success' },
  { value: AccessRequestStatus.Denied, name: 'Denied', badge: 'bg-secondary' },
  { value: AccessRequestStatus.Revoked, name: 'Revoked', badge: 'bg-dark' }
]

/** Open = nobody has decided yet. The listing's default filter. */
export const OPEN_STATUSES = [AccessRequestStatus.New, AccessRequestStatus.InReview, AccessRequestStatus.NeedsAccount]

const UNKNOWN_STATUS = { value: null, name: '', badge: 'bg-light text-dark' }

export function getAccessRequestStatus(value) {
  return accessRequestStatuses.find((status) => status.value === value) || UNKNOWN_STATUS
}

/**
 * What the decision buttons say for each target status. Reopening (back to InReview from
 * Denied/Revoked) reads differently from starting billing on a new request.
 */
export function actionFor(from, to) {
  switch (to) {
    case AccessRequestStatus.InReview:
      return [AccessRequestStatus.Denied, AccessRequestStatus.Revoked].includes(from)
        ? { label: 'Reopen', class: 'btn-outline-primary' }
        : { label: 'Start billing', class: 'btn-outline-primary' }
    case AccessRequestStatus.NeedsAccount:
      return { label: 'Needs account', class: 'btn-outline-warning' }
    case AccessRequestStatus.Approved:
      return { label: 'Approve and turn on access', class: 'btn-success' }
    case AccessRequestStatus.Denied:
      return { label: 'Deny', class: 'btn-outline-danger', needsReason: true }
    case AccessRequestStatus.Revoked:
      return { label: 'Revoke access', class: 'btn-outline-danger', needsReason: true }
    default:
      return { label: to, class: 'btn-outline-secondary' }
  }
}
